import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import MfaSettingPanel from './components/MfaSettingPanel';
import {
  isMfaSettingEnvironment,
  parseMfaEnabledParam
} from './mfaSettingUtils';

const MfaSetting = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const autoApplyEnabled = parseMfaEnabledParam(searchParams.get('isEnabled'));

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    if (!userId) {
      navigate('/login');
      return;
    }

    if (!isMfaSettingEnvironment()) {
      navigate('/settings');
    }
  }, [navigate]);

  return (
    <MfaSettingPanel autoApplyEnabled={autoApplyEnabled} showTitle={true} />
  );
};

export default MfaSetting;
